import '../styles/components/Contact.css'

export const ContactComponent = () => {
  return (
    <div className="contact-whatsapp">
      <a href="https://wa.me/50257586000">
        <img src="../assets/wa.png" alt="WhatsApp" />
      </a>
    </div>
  )
}
